import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@vue/reactivity';
import { getGlobalProps } from '@rednex/gateway_core';
import { inject } from 'vue';
import { onBeforeUnmount } from 'vue';
import { onMounted } from 'vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { watch } from 'vue';
//--- Function imports

//### Service imports
import { AlertService } from '@rednex/gateway_core';
import LoginService from '@/account/login.service';
import UserManagementService from '@/admin/user-management/user-management.service';
//--- Service imports

//### Model imports
import { languageOptions } from '@/shared/model/option-constants';
//--- Model imports

//### Component imports
import ChangePassword from '@/account/change-password/change-password-modal.vue';
import SearchComponent from '@/core/search/search.vue';
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'navigation-bar',
  setup(__props, { expose: __expose }) {
  __expose();

//### Function imports
const alertService = inject<AlertService>('alertService');
const loginService = inject<LoginService>('loginService');
const userManagementService = inject<UserManagementService>('userManagementService');

const globalProps = getGlobalProps();
const router = useRouter();
const store = useStore();
//--- Setup

//### Store/Reactive Data
const applicationIsBusy = computed(() => store.getters.applicationIsBusy);
const avatar = computed(() => store.getters.currentUser?.avatar);
const backButtonRoute = computed(() => store.getters.backButtonRoute);
const cardTitle = computed(() => store.getters.cardTitle);
const currentLanguage = computed(() => store.getters.currentLanguage);
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const isDesktopDevice = computed(() => store.getters.isDesktopDevice);
const isPhoneDevice = computed(() => store.getters.isPhoneDevice);
const loginName = computed(() => store.getters.currentUser?.login);
const menuExpanded = computed(() => store.getters.menuExpanded);
const showBackButton = computed(() => store.getters.showBackButton);
const themeMode = computed(() => store.getters.themeMode);

watch(
	() => {
		return store.getters.cardNavbarComponent;
	},
	cardNavbarComponent => {
		if (cardNavbarComponent) {
			ctxNavbar = cardNavbarComponent.navbarTemplate;
		}
	},
);
//--- Store/Reactive Data

//### Variables const let
const menuUserSettings = ref();
const modalChangePasswordVisible = ref(false);
const themeOptions = ref([
	{ icon: 'fa-regular fa-moon', value: 'dark' },
	{ icon: 'fa fa-lightbulb', value: 'light' },
]);

let ctxNavbar;
//--- Variables const let

//### Component Lifecycle
onMounted(() => {
	globalProps.emitter.on('close-password-modal', () => (modalChangePasswordVisible.value = false));
});

onBeforeUnmount(() => {
	globalProps.emitter.off('close-password-modal');
});
//--- Component Lifecycle

//### Functions
function changeLanguage(event: any): void {
	const newLanguage = event.value;
	if (newLanguage) {
		const currentUser = store.getters.currentUser;
		currentUser.langKey = newLanguage;

		userManagementService
			.update(currentUser)
			.catch(error => {
				alertService.showHttpError(globalProps, error);
			})
			.then(res => {
				if (res && res.data && res.data.langKey) {
					store.commit('currentLanguage', newLanguage);
				}
			});
	}
}

function switchTheme(event): void {
	const { value } = event;

	if (value && themeMode.value !== value) {
		store.commit('changeTheme', themeMode.value === 'light' ? 'dark' : 'light');
	}
}

function handlePasswordChangeClick() {
	modalChangePasswordVisible.value = true;
}

function handleLogoutClick() {
	loginService.logout().then(response => {
		store.commit('logout');

		window.location.href = response.data.logoutUrl;
		const next = response.data?.logoutUrl ?? '/';

		if (router.currentRoute.value.path !== next) {
			router.push(next);
		}
	});
}

function handleClickBack() {
	if (backButtonRoute.value) {
		router.push(backButtonRoute.value);
	} else {
		window.history.back();
	}
}

const toggleUserMenu = event => {
	menuUserSettings.value.toggle(event);
};

//--- Functions

const __returned__ = { alertService, loginService, userManagementService, globalProps, router, store, applicationIsBusy, avatar, backButtonRoute, cardTitle, currentLanguage, isAuthenticated, isDesktopDevice, isPhoneDevice, loginName, menuExpanded, showBackButton, themeMode, menuUserSettings, modalChangePasswordVisible, themeOptions, get ctxNavbar() { return ctxNavbar }, set ctxNavbar(v) { ctxNavbar = v }, changeLanguage, switchTheme, handlePasswordChangeClick, handleLogoutClick, handleClickBack, toggleUserMenu, get languageOptions() { return languageOptions }, ChangePassword, SearchComponent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})